export const J_ARRAYS = {
  J_dailyInterestAccounts: 'J_dailyInterestAccounts',
  J_highYieldAccounts: 'J_highYieldAccounts',
  J_guaranteedInterestAccounts: 'J_guaranteedInterestAccounts',
  J_benevaInvestmentAccounts: 'J_benevaInvestmentAccounts',
  J_benevaGuaranteedInvestmentFunds: 'J_benevaGuaranteedInvestmentFunds',
  J_predeterminedAllocations_plugin: 'J_predeterminedAllocations_plugin',
} as const;

export const J_ARRAYS_TYPE_FIELD = {
  J_dailyInterestAccounts: 'J_dailyInterestAccountDepositType',
  J_highYieldAccounts: 'J_highYieldAccountDepositType',
  J_guaranteedInterestAccounts: 'J_guaranteedInterestAccountDepositType',
  J_benevaInvestmentAccounts: 'J_benevaInvestmentAccountDepositType',
  J_benevaGuaranteedInvestmentFunds: 'J_benevaGuaranteedInvestmentFundDepositType',
  J_predeterminedAllocations_plugin: 'J_predeterminedAllocation|depositType',
} as const;

export const ALL_J_ARRAYS = [
  J_ARRAYS.J_dailyInterestAccounts,
  J_ARRAYS.J_highYieldAccounts,
  J_ARRAYS.J_guaranteedInterestAccounts,
  J_ARRAYS.J_benevaInvestmentAccounts,
  J_ARRAYS.J_benevaGuaranteedInvestmentFunds,
] as const;

export type J_Array = (typeof J_ARRAYS)[keyof typeof J_ARRAYS];
